module.exports = __webpack_public_path__ + "static/img/03@2x.ae0a74f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/03@2x.png
// module id = V5sj
// module chunks = 1